import { RequiredUserAction } from "@state/auth/types";
import { isGamesTheme } from "@utils";

export default class BlockUserActionService {
	static checkIfActionBlocked(requiredUserAction: RequiredUserAction) {
		const blockedUserActions = [
			RequiredUserAction.BettingActivity,
			RequiredUserAction.AccActivationCongratulation,
		];

		return (
			isGamesTheme() && blockedUserActions.includes(requiredUserAction)
		);
	}
}
